import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './OurFactory.module.css';
import API_BASE_URL from '../../config/api';

const OurFactory = () => {
  const { t, i18n } = useTranslation();
  const [factories, setFactories] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchFactories = async () => {
      try {
        const lang = i18n.language === 'ar' ? 'ar' : 'en';
        const res = await fetch(
          `${API_BASE_URL}/factories?lang=${lang}`,
          { signal: controller.signal },
        );
        const data = await res.json();
        const items = Array.isArray(data) ? data : data.data || [];

        setFactories(
          items.map((item) => ({
            id: item.slug,
            title: item.title,
            description: item.description,
            image: item.image_url || null,
          })),
        );
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Failed to load factories', error);
        }
      }
    };

    fetchFactories();

    return () => controller.abort();
  }, [i18n.language]);

  return (
    <div className={styles.factoryPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>{t('factory.title')}</h1>
          <div className={styles.heroUnderline}></div>
        </div>
      </section>

      {/* Factories Section */}
      <section className={styles.factoriesSection}>
        <div className={styles.container}>
          <div className={styles.factoriesGrid}>
            {factories.map((factory) => (
              <div key={factory.id} className={styles.factoryCard}>
                <div className={styles.imageContainer}>
                  {factory.image ? (
                    <img 
                      src={factory.image} 
                      alt={factory.title}
                      className={styles.factoryImage}
                    />
                  ) : (
                    <div className={styles.imagePlaceholder}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                        <circle cx="8.5" cy="8.5" r="1.5" />
                        <polyline points="21 15 16 10 5 21" />
                      </svg>
                      <span className={styles.imagePlaceholderText}>Factory Image</span>
                    </div>
                  )}
                </div>
                <div className={styles.cardContent}>
                  <h2 className={styles.factoryTitle}>{factory.title}</h2>
                  <p className={styles.factoryDescription}>{factory.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurFactory;
